module.exports = __webpack_public_path__ + "img/photo3.adb79c0f.png";